<template>
	<div class="number-input">
		<div class="number-input__button number-input__button--minus" @click="remove()"><icon name="minus" /></div>
		<input type="text" class="number-input__input" maxlength="3" pattern="[0-9]{3}" v-model.number="newAmount" @change="checkAmount($event)">
		<div class="number-input__button number-input__button--plus" @click="add()"><icon name="plus" /></div>
		<div class="number-input__warning" v-if="warning.show">{{warning.msg}}</div>
	</div>
</template>

<style lang="scss" scoped>
$size: 42px;
.number-input {
  display: inline-flex;
  align-items: stretch;
  position: relative;
  &__button {
    height: $size;
    width: $size;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #f5f5f5;
    border: 1px solid #ccc;
    box-shadow: none !important;
    cursor: pointer;
    &--minus {
      border-radius: 5px 0 0 5px;
    }
    &--plus {
      border-radius: 0 5px 5px 0;
    }
  }
  &__input {
    height: $size;
    width: $size;
    padding: 0 5px;
    text-align: center;
    border: none;
    border-top: 1px solid #ccc;
    border-bottom: 1px solid #ccc;
  }
  &__warning {
    position: absolute;
    left: 50%;
    bottom: 75%;
    transform: translateX(-50%);
    background: #f00;
    color: #fff;
    font-size: 13px;
    margin-bottom: 5px;
    padding: 5px;
    white-space: nowrap;
    &:after {
      content: "";
      position: absolute;
      left: 50%;
      margin-left: -5px;
      bottom: -5px;
      width: 10px;
      height: 10px;
      background: inherit;
      transform: rotate(45deg);
    }
  }
}
</style>

<script>
export default {
	name: 'numberInput',
	props:{
		amount: {
			type: Number,
			required: true
		},
		steps: {
			type: Number,
			required: false
		},
		min: {
			type: Number,
			required: false
		},
		max: {
			type: Number,
			required: false
		},
	},
	watch:{
		amount(newVal, oldVal){
			this.newAmount = newVal
		}
	},
	methods:{
		add(){
			this.newAmount = this.newAmount + this.steps
			this.checkAmount()
		},
		remove(){
			this.newAmount = this.newAmount - this.steps
			this.checkAmount()
		},
		checkAmount(event){
			var amount
			var lang = this.$store.getters.language

			// check for events instead of this.newAmount, because of scanner issues
			if(!event){
				amount = this.newAmount
			}else{
				// make number of input
				var input = Number(event.target.value)
				if(isNaN(input)){
					// not valid input
					if(this.prevAmount){
						// set old input
						amount = this.prevAmount
					}else{
						// set minimum amount
						amount = this.steps
					}
				} else {
					// valid input
					amount = input
				}
			}

			var min = this.min
			var max = this.max
			var steps = this.steps
			function isInteger(x) {
				return (typeof x === 'number') && (x % 1 === 0)
			}
			if(steps !== undefined && !isInteger(amount / steps)){
				amount = Math.round(amount / steps) * steps
				if(lang === 'nl'){
					this.showWarning(`Alleen een meervoud van ${steps} toegestaan`)
				}
				if(lang === 'fr'){
					this.showWarning(`Seul un multiple de ${steps} est autorisé`)
				}
			}
			if(max !== undefined && amount > max){
				amount = Math.floor(max / steps) * steps
				if(lang === 'nl'){
					this.showWarning(`Maximale aantal: ${amount}`)
				}
				if(lang === 'fr'){
					this.showWarning(`Nombre maximum: ${amount}`)
				}
			}
			if (min !== undefined && amount < min){
				amount = min
				if(lang === 'nl'){
					this.showWarning(`Minimale aantal: ${min}`)
				}
				if(lang === 'fr'){
					this.showWarning(`Nombre minimum: ${min}`)
				}
			}
			this.newAmount = amount
			this.prevAmount = amount
			this.$emit('update', amount)
		},
		showWarning(msg){
			this.warning = {
				show: true,
				msg: msg
			}
			var self = this
			setTimeout(function(){
				self.warning.show = false
			}, 1500)
		}
	},
	data(){
		return{
			newAmount: Number(this.amount),
			prevAmount: '',
			warning: {
				show: false,
				msg: ''
			}
		}
	}
}
</script>